<template>
  <div>
    <Fontnavbar title="物流详情" />
    <div class="content">
      <div class="log_top">
        <div class="right">
          <div>物流公司：{{ logistic_name }}</div>
          <div>物流单号：{{ logistic_no }}</div>
        </div>
      </div>
      <div class="log_list" v-if="logList.length !=0">
        <div class='logisit' v-for="(item,index) in logList" :key="index">
          <div class='list' :style="{'border-left':index == logList.length-1 ? '':'1px solid #E5E5E5'}">
            <div class="left">
              <van-image class='list_start_img' v-if="index == 0&&logList.length>1" src="/static/circle.png"></van-image>
              <van-image class='list_start_img' v-if="index != 0" src="/static/gantan_icon3.png"></van-image>
            </div>
            <div class="right">
              <div :class="index == 0 ? 'list_name_last' : 'list_name' ">{{item.context}}</div>
              <div :class="index == 0 ? 'list_dates_last' : 'list_dates' ">{{item.time}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import { kuaiDi } from '../../api.js'
import { post } from '../../request.js'
import { Toast } from 'vant'
import Fontnavbar from "../../components/Navbar.vue";
import {
  Image,
} from "vant";
export default {
  components: {
    [Image.name]: Image,
    Fontnavbar
  },

  data () {
    return {
      logistic_code: '',
      logistic_no: '',
      logistic_name: '',
      logList: []
    }
  },
  created () {
    console.log(this.$route.query)
    this.logistic_code = this.$route.query.logistic_code
    this.logistic_no = this.$route.query.logistic_no
    this.logistic_name = this.$route.query.logistic_name
    this.init()
  },

  methods: {
    init(){
      post(kuaiDi,{
        logistic_code: this.logistic_code,
        logistic_no:this.logistic_no
        // logistic_no: 75816999188836
      }).then(res=>{
        console.log('res: ', res);
        if(res.data.data){
          this.logList = res.data.data
        }else{
          Toast(res.data.message)
        }
      })
    }
  },
}
</script>

<style lang="less" scoped>
.content {
  .log_top {
    padding:10px 20px;    
    border: 1px solid #f5f5f5;
    background-color: #ffffff;
    .right {
      font-size: 14px;
      color: #333333;
      div {
        line-height: 30px;
      }
    }
  }
  // 物流追踪
  .log_list {
    margin-top: 30px;
    .list {
      width: 90%;
      margin: auto;
      display: flex;
      justify-content: flex-start;
      position: relative;
      .left {
        margin-left: 10px;
        position: absolute;
        left: -26px;
        width: 30px;
        text-align: center;
        .list_start_img {
          width: 22px !important;
          height: 22px !important;
        }
      }
      .right {
        font-size: 14px;
        width: 90%;
        margin-left: 20px;
        margin-bottom: 20px;
        .list_name_last,
        .list_name {
          width: 100%;
          text-align: left;
        }
        .list_name_last {
          color: #892c2b;
        }
        .list_name {
          color: #999999;
        }
        .list_dates_last {
          color: #892c2b;
          margin-top: 10px;
        }
        .list_dates {
          margin-top: 10px;
          color: #999999;
        }
      }
    }
  }
}
</style>